import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
        mode: 'light', // switch to 'dark' for dark mode
        primary: {
        main: '#ff0000',
        light: '#ff5252',
        dark: '#c50000',
        },
        secondary: {
        main: '#667eea',
        light: '#8e99f3',
        dark: '#4c63d2',
        },
        success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#047857',
        },
        warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        },
        error: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        },
        info: {
        main: '#3b82f6',
        light: '#60a5fa',
        dark: '#2563eb',
        },
        background: {
        default: '#ffffff',
        paper: '#ffffff',
        },
        text: {
        primary: '#1a202c',
        secondary: '#4a5568',
        disabled: '#a0aec0',
        },
        divider: '#e2e8f0',
    },
    border: {
        main: '#757575',
        light: '#eeeeee',
    },
    typography: {
        fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,
        fontSize: 16,
        h1: { fontSize: '2.25rem', fontWeight: 700, lineHeight: 1 },
        h2: { fontSize: '1.875rem', fontWeight: 600 },
        h3: { fontSize: '1.5rem', fontWeight: 600 },
        h4: { fontSize: '1.25rem', fontWeight: 600 },
        h5: { fontSize: '1.125rem', fontWeight: 600 },
        h6: { fontSize: '1rem', fontWeight: 600 },
        body1: { fontSize: '1rem' },
        body2: { fontSize: '0.875rem' },
    },
    shape: {
        borderRadius: 8, // maps to --radius-md
    },
    spacing: (factor: number) => `${0.25 * factor}rem`, // maps to --spacing-[]
    shadows: [
        'none', // 0
        '0 1px 2px rgba(0, 0, 0, 0.05)', // 1: shadow-xs
        '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)', // 2: shadow-sm
        '0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)', // 3: shadow-md
        '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)', // 4: shadow-lg
        '0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04)', // 5: shadow-xl
        '0 25px 50px rgba(0, 0, 0, 0.25)', // 6: shadow-2xl
        ...Array(18).fill('none'), // shadows[7] to shadows[24]
    ],
    }
);
export default theme;
